import React from "react";

function ResirveIcon() {
  return (
    <svg
      width="25"
      height="25"
      fill="#fff"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="APRES-VENTE"
        stroke="none"
        strokeWidth="1"
        fill="#fff"
        fillRule="evenodd"
      >
        <g
          id="DOSSIER-VOYAGE---NON-CONNECTE"
          transform="translate(-760.000000, -1427.000000)"
          fill="#fff"
        >
          <g
            id="boutons-actions"
            transform="translate(736.000000, 1416.000000)"
          >
            <g id="Boutons/Outline-Default-Icone">
              <g id="icons/infos" transform="translate(24.000000, 11.000000)">
                <path
                  d="M6.97053111,1.05882353 L6.97053111,5.81320174 L5.59036446,5.81320174 L5.59036446,2.68497561 C3.98504662,3.51373345 2.73530572,4.79359312 2.01692898,6.36581818 C1.16186973,8.23716514 1.16191574,10.2983619 2.01692898,12.1697089 C3.14392706,14.6362967 5.55645836,16.3536201 8.47058824,16.7635572 L8.47058824,16.7635572 L8.25891668,18 C6.63542665,17.771613 5.089686,17.1705331 3.78892494,16.2617815 C2.44721893,15.3244189 1.39355371,14.0750052 0.741793009,12.6485458 C-0.968417494,8.90551823 0.380649402,4.69416387 3.73905492,2.31003057 L3.73905492,2.31003057 L1.72608186,2.31003057 L1.72608186,1.05882353 L6.97053111,1.05882353 Z M9.74090607,1.42108547e-14 C11.3633892,0.228386991 12.9081712,0.829466853 14.2081715,1.73826023 C15.5490454,2.67558113 16.6020571,3.92499477 17.2534136,5.35145421 C18.2488621,7.53155735 18.2488621,9.9328739 17.2534136,12.112977 C16.6009997,13.5417304 15.5721259,14.7633672 14.2639416,15.6899694 L14.2639416,15.6899694 L16.2696892,15.6899694 L16.2696892,16.9411765 L11.0285386,16.9411765 L11.0285386,12.1867983 L12.4078492,12.1867983 L12.4078492,15.3150244 C14.0121255,14.4862666 15.2611373,13.2064069 15.9790225,11.6341818 C16.8335055,9.76283486 16.8335055,7.7016381 15.9790225,5.83029114 C14.8527234,3.36370329 12.4416883,1.64637993 9.52941176,1.2364428 L9.52941176,1.2364428 Z"
                  id="Combined-Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ResirveIcon;
